
    <label class="switch">
        <input type="checkbox" class="switch-input" [checked]="toggle" (click)="change()">
        <span class="switch-label"></span>
        <span class="switch-handle"></span>
    </label> {{toggleName}}
  